<div class="customer-support">
    <div class="topOfPage">
      <div class="header">
        <h1 tabindex="0">{{ state.pageHeading }}</h1>
      </div>
    </div>
    <hr *ngIf="showHr"/>
    <div class="tab-section">
        <div class="title">{{state.title }}</div>
        <div class="description">{{state.description }}</div>
        <div class="d-flex">
          <div class="section-block">
            <label for="email-label" class="email-label">
              {{ state.email }}
            </label>
            <input type="text" class="form-control" [placeholder]="state.email" (input)="checkEmail()" [(ngModel)]="email" [ngClass]="{'error-input': state.isInvalid}"/>
            <div class="error-message" *ngIf="state.isInvalid" role="alert" tabindex="0">
              {{state.emailErrorMessage}}
            </div>
          </div>
          <div>
            <kng-button class="startSession-btn" [state]="state.startCTA" (clicked)="startSession()"></kng-button>
          </div>
        </div>
    </div>
</div>

<kng-modal-component #confirmSessionState  *ngIf="!confirmSession.hidden" [state]="confirmSession" (ctaClickedOn)="confirmModalEvent($event)" >
  <div class="start-session-text">
    {{state.startSession}}
  </div>
  <div class="row customer-support__userData ">
    <div class="col-4 content-block">
      <div class="label">Email ID</div>
      <div class="value"> {{ service.userData.email }} </div>
    </div>
    <div class="col-4 content-block">
      <div class="label">Name</div>
      <div class="value"> {{ service.userData.name }} </div>
    </div>
    <div class="col-4 content-block">
      <div class="label">Role</div>
      <div class="value"> {{ service.userData.role }} </div>
    </div>
  </div>
</kng-modal-component>
  
<div class="loader" *ngIf="state.loading">
  <kng-loader [state]="loaderState"></kng-loader>
</div>
  
  
  